import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../../assets/styles/DucksIndividualView.module.scss';
import BackButton from '../../components/BackButton/BackButton';

interface Duck {
    name: string;
    gender: string;
    description: string;
    imageUrl: string;
}

const DucksIndividualView: React.FC = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const duck = state as Duck;

    if (!duck) {
        return (
            <div className={styles.fallback}>
                <p>Duck not found. Please return to the flock.</p>
                <BackButton to="/ducks" />
            </div>
        );
    }

    return (
        <div className={styles.profile}>
            <BackButton to="/ducks" />
            <div className={styles.imageContainer}>
                <img src={duck.imageUrl} alt={duck.name} className={styles.image} />
            </div>
            <h1 className={styles.name}>{duck.name}</h1>
            <p className={styles.gender}>({duck.gender})</p>
            <p className={styles.description}>{duck.description}</p>
        </div>
    );
};

export default DucksIndividualView;
